// extracted by mini-css-extract-plugin
export default {"layout":"toast_layout__chtTm","modal":"toast_modal__cZnCb","message":"toast_message__Pkp5j","footer":"toast_footer__zBs8d","button":"toast_button__X3LBk"};